module.exports = __webpack_public_path__ + "img/fond-zebre.68d8935b.jpg";